import React from "react";
import "./OneTimePasscode.scss";

import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { emailSchema } from "./formValidation";
import { useHistory, Link } from "react-router-dom";

import { Button } from "@thrivetribe/gloji.ui.atoms.button";
import PageBg from "../../../assets/img/bg/eligibilityCheckerBg.png";
import {
  ModalPageBackground,
  ModalPageBody,
  ModalPageWrapper,
  ModalPageCopy,
  ModalPageHeading,
  ModalPageHeader,
} from "../../organisms/ModalPage";
import Toast from "../../atoms/Toast";
import Toastify from "../../atoms/Toastify";

import { ReactComponent as Logo } from "../../../assets/img/logo.svg";
import TextField from "../../atoms/react-hook-form/TextField/TextField";
import { useRequestOtpMutation } from "../../../redux/profileApiV3";

interface OtpEmailType {
  email?: string;
}

export const OneTimePasscodeRequest: React.FC = () => {
  const [requestOtp, { isSuccess }] = useRequestOtpMutation();

  const history = useHistory();

  const { handleSubmit, control, getValues } = useForm<OtpEmailType>({
    resolver: yupResolver(emailSchema),
    defaultValues: { email: "" },
  });

  const onSubmit = (values) => {
    requestOtp(values.email)
      .unwrap()
      .then((fulfilled) => {
        localStorage.removeItem("otpState");
        history.push(`/sign-up/otp/verify/${values.email}`);
        Toastify.success(`We've sent an email to ${values.email}`);
        console.log(fulfilled);
      })
      .catch((rejected) => console.error(rejected));
  };

  return (
    <ModalPageBackground className="otp-page" bgImage={PageBg}>
      <Helmet>
        <title>Lets team up | Eligibility checker | Sign up | Gloji</title>
      </Helmet>
      <ModalPageWrapper className="otp-email" alignItems="center">
        <ModalPageBody hasStickyFooter={false}>
          <>
            <ModalPageHeader
              backButtonOnClick={() => {
                window.location.href = "https://www.gloji.co.uk";
              }}
              backButtonText="Cancel"
            >
              <Logo id="glojiHeaderLogo" />
            </ModalPageHeader>
            <ModalPageHeading size="large">
              Let’s start with your email
            </ModalPageHeading>
            <ModalPageCopy>
              Enter your email address and we’ll send you a code that you can
              use to get started by picking your programme.
            </ModalPageCopy>
          </>
          <form onSubmit={handleSubmit(onSubmit)} className="form email">
            <div className="form__body">
              <TextField label="Email address" name="email" control={control} />
            </div>
            <Button type="submit" variant="contained" color="primary">
              Send code
            </Button>
          </form>
          <div className="otp-email__have-account">
            <span>Already have an account?</span>
            <Link
              to="/"
              className="programme-card__container-link secondary"
              aria-label="Sign in"
            >
              Sign in
            </Link>
          </div>
        </ModalPageBody>
      </ModalPageWrapper>
      <Toast show={isSuccess} type="success">
        We've sent an email to {getValues().email}
      </Toast>
    </ModalPageBackground>
  );
};
